var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIconRoadmap = function SvgInfoIconRoadmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeMiterlimit: 10,
    d: "M9.011 17c4.425 0 8.011-3.582 8.011-8s-3.586-8-8.01-8C4.586 1 1 4.582 1 9s3.587 8 8.011 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeMiterlimit: 10,
    d: "M6.734 6.53a2.274 2.274 0 0 1 2.54-2.251c1.05.109 1.882.962 2.013 2.01a2.25 2.25 0 0 1-1.182 2.252c-.657.35-1.072 1.006-1.072 1.749v.721M9.011 13.721a.59.59 0 1 0 .001-1.18.59.59 0 0 0 0 1.18Z"
  })));
};
export default SvgInfoIconRoadmap;